import { createAction, props } from '@ngrx/store';
import { IEmployeeHourType } from './../../home.model';

export const loadCalendarEvents = createAction(
  '[Home] Load Calendar Events',
  props<{ employeeNumber: number; selectedDate: string }>()
);

export const loadCalendarEventsSuccess = createAction(
  '[Home] Load Calendar Events Success',
  props<{ calendarEvents: any[] }>()
);

export const loadCalendarEventsFailure = createAction(
  '[Home] Load Calendar Events Failure',
  props<{ error: string }>()
);

export const loadEmployeeHours = createAction(
  '[Home] Load Employee Hours',
  props<{ employeeNumber: number; date: string }>()
);

export const loadEmployeeHoursSuccess = createAction(
  '[Home] Load Employee Hours Success',
  props<{ employeeHours: IEmployeeHourType[] }>()
);

export const loadEmployeeHoursFailure = createAction(
  '[Home] Load Employee Hours Failure',
  props<{ error: string }>()
);

export const loadEmployeeStatus = createAction(
  '[Home] Load Employee Status',
  props<{ employeeNumber: number }>()
);

export const loadEmployeeStatusSuccess = createAction(
  '[Home] Load Employee Status Success',
  props<{ clockStatus: any }>()
);

export const loadEmployeeStatusFailure = createAction(
  '[Home] Load Employee Status Failure',
  props<{ error: string }>()
);
